import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "styles/main.scss";
import CustomButton from "custom/button/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "features/cart/cartSlice";
import { selectCurrentUser } from "features/user/userSlice";
import { useNavigate, useParams } from "react-router-dom";
import AddToCartButton from "containers/AddToCartButton";

export default function CollectionCategoriesItem({ item, category }) {
  const navigate = useNavigate();

  return (
    <div
      className="CollectionCategoriesItem__items mb-12 w-full relative h-96 group cursor-pointer"
      onClick={() =>
        navigate(`/shop/${category}/${item.id}`, { state: { item } })
      }
    >
      <div className="overflow-hidden rounded-2xl w-full h-full">
        <img
          src={item.imageUrl}
          alt="item"
          className="CollectionCategoriesItem__items-img w-full object-cover rounded-2xl group-hover:opacity-70 xl:scale-100"
        />
      </div>
      <div className="absolute mt-auto bottom-16 right-0 left-0 mx-auto w-4/5 hidden group-hover:block">
        <AddToCartButton
          id={item.id}
          imageUrl={item.imageUrl}
          name={item.name}
          description={item?.description}
          price={item.price}
          category={category}
        />
      </div>
      <div className="CollectionCategoriesItem__items-info flex justify-between">
        <p className="CollectionCategoriesItem__items-infoName text-lg">
          {item.name}
        </p>
        <p className="CollectionCategoriesItem__items-infoPrice font-bold">
          {item.price}₫
        </p>
      </div>
    </div>
  );
}
